import { render, staticRenderFns } from "./RecipeItemIngredientEdit.vue?vue&type=template&id=defdda32&scoped=true&"
import script from "./RecipeItemIngredientEdit.vue?vue&type=script&lang=js&"
export * from "./RecipeItemIngredientEdit.vue?vue&type=script&lang=js&"
import style0 from "./RecipeItemIngredientEdit.vue?vue&type=style&index=0&id=defdda32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defdda32",
  null
  
)

export default component.exports